import { FunctionComponent } from 'react';
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableCaption,
} from '@chakra-ui/react';
import { gweiToEth } from '../../imports/utils';

export type TransactionCostProps = {
    gasPrice: number;
    gasLimit: number;
};

const TransactionCost: FunctionComponent<TransactionCostProps> = ({
    gasPrice,
    gasLimit,
}) => {
    return (
        <Table variant='simple'>
            <TableCaption>Calcolo delle commissioni</TableCaption>
            <Thead>
                <Tr>
                    <Th>Prezzo gas (Gwei)</Th>
                    <Th>Gas Richiesto</Th>
                    <Th isNumeric>Totale (Eth)</Th>
                </Tr>
            </Thead>
            <Tbody>
                <Tr>
                    <Td>{gasPrice}</Td>
                    <Td>{gasLimit}</Td>
                    <Td isNumeric>{gweiToEth(gasPrice * gasLimit)}</Td>
                </Tr>
            </Tbody>
        </Table>
    );
};

export default TransactionCost;
